export default {
  h1: {
    fontWeight: 500,
    fontSize: 53,
    letterSpacing: '-0.24px'
  },
  h2: {
    fontWeight: 500,
    fontSize: 44,
    letterSpacing: '-0.24px'
  },
  h3: {
    fontWeight: 500,
    fontSize: 36,
    letterSpacing: '-0.06px'
  },
  h4: {
    fontWeight: 500,
    fontSize: 30,
    letterSpacing: '-0.06px'
  },
  h5: {
    fontWeight: 500,
    fontSize: 24,
    letterSpacing: '-0.05px'
  },
  h6: {
    fontWeight: 500,
    fontSize: 21,
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 500
  },
  subtitle1: {
    fontWeight: 500,
    fontSize: "1.5rem",
    letterSpacing: '-0.05px'
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: "1.3125rem",
    letterSpacing: '-0.05px'
  },
  body1: {
    fontWeight: 500,
    fontSize: "1.5rem",
    letterSpacing: '-0.05px'
  },
  body2: {
    fontWeight: 500,
    fontSize: "1.3125rem",
    letterSpacing: '-0.05px'
  },
  caption: {
    fontWeight: 500,
    fontSize: "1.125rem",
    letterSpacing: '-0.05px'
  },
  logo: {
    fontWeight: 500,
    fontSize: 32,
    letterSpacing: '-0.05px'
  },
  logoxs: {
    fontWeight: 500,
    fontSize: 23,
    letterSpacing: '-0.05px'
  }
};
